export const SET_USER = 'SET_USER';
export const SET_AUTH = 'SET_AUTH';
export const LOGOUT = 'LOGOUT';
export const FETCH_USER_INFO = 'FETCH_USER_INFO';
